<rask-page
    pageTitle="Sök extern arbetsorder"
    noPadding
    [footerShow]="false">
    <ng-container headerContent>
        <rask-extern-arbetsorder-search-panel></rask-extern-arbetsorder-search-panel>
        <rask-extern-arbetsorder-search-result></rask-extern-arbetsorder-search-result>
    </ng-container>
</rask-page>

